<div *ngIf="loading ==true"
  style="display: flex;flex-direction: column;align-items: center;justify-content: center;min-height: 600px;align-self: center;">
  <mat-spinner></mat-spinner>
</div>

<mat-card *ngIf="loading !=true" 
style="display: flex;flex-direction: column;min-height: 600px;height: 90%;
padding-left: 20px;padding-right: 20px;margin-top: 30px;
    margin-left: 10px;
    margin-right: 10px;">

  <!-- <div style="display: flex;align-self: center;margin-top: 20px;">
    <h1>Create Forms</h1>
  </div> -->
  <mat-card-title>
   Create Forms
  </mat-card-title>

  <mat-card-subtitle>
    <div style="display: flex;flex-direction: row;justify-content: space-between;">
      <mat-form-field class="action-input">
        <input placeholder="Form Name" style="width: 500px;height: 40px;margin-top: 10px;" type="text" 
      matInput [(ngModel)]="FormName" (change)="FormNameChange()" class="get-Input">
      </mat-form-field>
  
      <div style="display: flex;flex-direction: column;justify-content: center;
      align-items: center;">
        <span style="text-decoration: underline;">Email On Complete</span>
        <mat-checkbox style="margin-top: 10px;" [checked]="isSendEmail" (change)="toggleEmailOnComplete()"></mat-checkbox>
      </div>
  
    </div>

  </mat-card-subtitle>

  


    <mat-card-content>
      <table class="table table--full-width table--striped" style="margin-top: 9px;"
      *ngFor="let fc of DigitalFormSetupData?.FormListV1">
      <thead>
        <tr>
          <th style="display: flex;
          flex-direction: row;
          margin-bottom: 20px;margin-top: 20px">
            <span style="text-decoration: underline;font-size: 30px;">{{fc.FormCategory.QCategoryName}}</span>
            <i (click)="onClickEditSection(fc.FormCategory)" class="material-icons button__icon"
                    style="color:black;cursor: pointer;margin-right: 20px;">edit</i>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr style="background-color: rgb(221, 221, 221);">
          <td >
            <div style="display: flex;flex-direction: row;justify-content: space-between;flex: 1;margin-top: 10px;">
              <div style="flex:0.5;display: flex;flex-direction: column;">
                <div style="flex:1;display: flex"></div>
                <div style="flex:1;display: flex">
                 
                   
                </div>
              </div>
  
              <div style="flex:2;display: flex;flex-direction: column;">
                <div style="flex:1;display: flex;font-weight: bold;"><span>Question</span></div>
                
              </div>
  
              <div style="flex:1;display: flex;flex-direction: column;justify-content: center;
              align-items: center;">
                <div style="flex:1;display: flex;font-weight: bold;"><span>Type</span></div>
             
              </div>
  
              <div style="flex:1;display: flex;flex-direction: column;justify-content: center;
              align-items: center;">
                <div  style="flex:1;display: flex;font-weight: bold;"><span>Ans</span></div>
              
              </div>
  
              <div  style="flex:1;display: flex;flex-direction: column;justify-content: center;
              align-items: center;">
                <div style="flex:1;display: flex;font-weight: bold;"><span>Has Image</span></div>
            
              </div>
  
              <div style="flex:1;display: flex;flex-direction: column;justify-content: center;
              align-items: center;">
                <div style="flex:1;display: flex;font-weight: bold;"><span>Image Editable</span></div>
               
              </div>
  
              <div style="flex:1;display: flex;flex-direction: column;justify-content: center;
              align-items: center;">
                <div style="flex:1;display: flex;font-weight: bold;"><span>Add Image</span></div>
                
              </div>
  
              <div style="flex:1;display: flex;flex-direction: column;justify-content: center;
              align-items: center;">
                <div style="flex:1;display: flex;font-weight: bold;"><span> </span></div>
                
              </div>
  
              <div style="flex:1;display: flex;flex-direction: column;justify-content: center;
              align-items: center;">
                <div style="flex:1;display: flex;font-weight: bold;"><span> </span></div>
                
              </div>
  
            </div> 
          </td>
        </tr>
        <tr *ngFor="let f of fc.Questions">
  
          <td >
            <div style="display: flex;flex-direction: row;justify-content: space-between;flex: 1;margin-top: 10px;">
              <div style="flex:0.5;display: flex;flex-direction: column;">
                <!-- <div style="flex:1;display: flex"></div> -->
                <div style="flex:1;display: flex">
                  <i (click)="onClickDone(f)" class="material-icons button__icon"
                    style="color:green;cursor: pointer;margin-right: 20px;">done</i>
                </div>
              </div>
  
              <div style="flex:2;display: flex;flex-direction: column;">
           
                <div style="flex:1;display: flex;flex-direction: row;">
                  <span>{{f.QTitle}}</span>
                  
                </div>
              </div>
  
              <div style="flex:1;display: flex;flex-direction: column;justify-content: center;
              align-items: center;">
               
                <div style="display: flex;
                flex-direction: row;
                padding-top: 2px;
                
                justify-content: space-between;
                align-items: center;
                ">
                  <span style="width: 200px;padding-right: 10px;
                  padding-bottom: 10px;padding-left: 10px;
                padding-top: 10px;">{{f.QuestionTypeName}}</span>
                  <i (click)="onClickEditQuestion(f)" class="material-icons button__icon"
                    style="color:black;cursor: pointer;margin-right: 20px;">edit</i>
                </div>
              </div>
  
              <div style="flex:1;display: flex;flex-direction: column;justify-content: center;
              align-items: center;">
                <div *ngIf="f.QuestionTypeId == 1 || f.QuestionTypeId == 2 || f.QuestionTypeId == 3" style="flex:1;display: flex">
                  <i (click)="onClickEditAnswer(f)" class="material-icons button__icon"
                    style="color:black;cursor: pointer;">comment</i>
                </div>
              </div>
  
              <div  style="flex:1;display: flex;flex-direction: column;justify-content: center;
              align-items: center;">
                <div style="flex:1;display: flex">
                  <i (click)="inputValueImage.click()" class="material-icons button__icon"
                    style="color:black;cursor: pointer;margin-right: 20px;">{{f.HasQuestionImage ? "insert_photo":"wallpaper"}}
                    <input  #inputValueImage type="file" accept="image/*" style="display:none" (change)="onFileChanged($event, f);">
                  </i>
                </div>
              </div>
  
              <div style="flex:1;display: flex;flex-direction: column;justify-content: center;
              align-items: center;">
                <div style="flex:1;display: flex">
                  <mat-checkbox [(ngModel)]="f.ImageEdit"  (change)="toggleImageEdit(f.QuestionId)"></mat-checkbox>
                </div>
              </div>
  
              <div style="flex:1;display: flex;flex-direction: column;justify-content: center;
              align-items: center;">
                <div style="flex:1;display: flex">
                  <mat-checkbox [(ngModel)]="f.AllowImages" (change)="toggleAllowImage(f.QuestionId)"></mat-checkbox>
                </div>
              </div>
  
              <div  style="flex:1;display: flex;flex-direction: column;justify-content: center;
              align-items: center;">
                <div *ngIf="f.ShowDownArrow == true"  style="flex:1;display: flex">
                  <i (click)="onClickArrowDown(f)" class="material-icons button__icon"
                    style="color:black;cursor: pointer;">arrow_drop_down</i>
                </div>
              </div>
  
              <div style="flex:1;display: flex;flex-direction: column;justify-content: center;
              align-items: center;">
                <div *ngIf="f.ShowUpArrow == true" style="flex:1;display: flex">
                  <i (click)="onClickArrowUp(f)" class="material-icons button__icon"
                    style="color:black;cursor: pointer;">arrow_drop_up</i>
                </div>
              </div>
  
            </div> 
          </td>
        </tr>
  
        <div style="display: flex;justify-content: flex-end;margin-top: 10px;">
          <button class="button button--primary" style="margin-left: 20px;width: 200px;align-self: flex-end;"
            (click)="onClickAddQuestion(fc.FormCategory)">
            <span class="button__text">+ Add Question</span>
          </button>
        </div>
      </tbody>
    </table>
  </mat-card-content>

    
  <mat-card-actions>
    <button class="button button--primary" style="margin-left: 20px;width: 200px;align-self: flex-end;"
    (click)="onClickAddSection(cat)">
    <span class="button__text">+ Add Section</span>
  </button>

  </mat-card-actions>

    

</mat-card>